import EcoTitle from 'eco-design/base/eco-title';
import Sector from './components/Sector';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import useSwiperAni from './useSwiperAni';
import { useEffect, useRef } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const N: React.FC = () => {
    const { t } = useLang('ats.N');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-N');
    const list = [
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942794407/Swiper_pc_step_01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758942839315/Swiper_pc_step_01.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942794002/Swiper_m_step_01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758942838651/Swiper_m_step_01.webp',
            ),
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942794915/Swiper_pc_step_02.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758942839538/Swiper_pc_step_02.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1758942795117/Swiper_m_step_02.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1758942838848/Swiper_m_step_02.webp',
            ),
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1760171911939/pc_step_03.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760171922807/pc_step_03.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1760171912108/m_step_03.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760171922641/m_step_03.webp',
            ),
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
    ];

    const sectionRef = useRef<HTMLDivElement>(null);
    const { angle, index } = useSwiperAni({
        length: list.length,
        sectionRef: sectionRef,
    });

    /** 动画 */
    useEffect(() => {
        if (!sectionRef.current) return;
        const ani1El = sectionRef.current?.querySelector('.ani-1');
        const ani2El = sectionRef.current?.querySelector('.ani-2');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                ani1El?.classList.add('enter');
                ani2El?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    ani1El?.classList.remove('enter');
                    ani2El?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);

    const swiperList = list.length;
    return (
        <>
            <EcoSpace className={css.space1} />
            <section
                className={`${css.section} smart-gateway-N GtmModuleData-section`}
                id="smart-gateway-N"
                data-section-id={'smart-gateway-N'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="content">
                    <div className="info">
                        <EcoTitle className="ani-1" title={t('title')} />
                    </div>
                    <div className="container ani-2">
                        <EcoImg pc={list[index - 1]?.pc} h5={list[index - 1]?.h5} />
                        <div className="info">
                            {/* 扇形展开动画 */}
                            <div className="circle">
                                <Sector angle={angle} />
                                {angle >= 360 ? (
                                    <svg className="icon-gou" xmlns="http://www.w3.org/2000/svg" width="58" height="41" viewBox="0 0 58 41" fill="none">
                                        <path
                                            d="M2.0176 20.4316C2.55259 20.9666 14.055 32.469 19.7393 38.1534L56.1553 1.73735"
                                            stroke="white"
                                            strokeWidth="4"
                                        />
                                    </svg>
                                ) : (
                                    <span className="circle-text">{index}</span>
                                )}
                            </div>
                            <div>
                                <div className="info-title">{list[index - 1]?.title}</div>
                                <div className="info-desc">{list[index - 1]?.desc}</div>
                                {/* h5 出现 */}
                                <div className="indexs-h5">
                                    {list.map((_i, idx) => (
                                        <div className={`index-item-h5 ${index === idx + 1 ? 'active' : ''}`} key={idx}></div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="indexs">
                            {list.map((_i, idx) => (
                                <div className={`index-item ${index === idx + 1 ? 'active' : ''}`} key={idx}></div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <EcoSpace className={css.space2} />
        </>
    );
};

export default N;
